import React, { useState, useEffect } from 'react';
import { Gift } from 'lucide-react';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="header-logo" onClick={scrollToTop}>
          <div className="logo-icon-header">
            <Gift className="w-6 h-6" />
          </div>
          <span className="logo-text-header">GiftEmotion</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
